import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template-rtl',
  templateUrl: './template-rtl.component.html',
  styleUrls: ['./template-rtl.component.css']
})
export class TemplateRtlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
